// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__BDUcw","pageNext":"pagination_pageNext__zrYVJ","pageNumber":"pagination_pageNumber__6FdsW","activeBg":"pagination_activeBg__LM7q2"};